const STORE_KEY = '__mock_sms_send_task_store__';

const getGlobal = () => {
  if (typeof window !== 'undefined') return window;
  return {};
};

const pad2 = (num) => String(num).padStart(2, '0');
const formatDateTime = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(
    d.getMinutes()
  )}:${pad2(d.getSeconds())}`;
};

const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const randPick = (arr) => arr[randInt(0, arr.length - 1)];

const buildContent = ({ templateName, smsContent }) => {
  if (smsContent) return smsContent;
  if (templateName) return `【模板】${templateName}`;
  return '-';
};

const generateTasks = () => {
  const now = Date.now();
  const dayMs = 24 * 60 * 60 * 1000;

  const templateNames = [
    '注册验证码',
    '登录验证码',
    '订单通知',
    '物流通知',
    '营销活动',
    '会员提醒',
    '欠费提醒',
  ];

  const finished = Array.from({ length: 18 }).map((_, idx) => {
    const sendAt = now - randInt(1, 89) * dayMs - randInt(0, 23) * 60 * 60 * 1000;
    const createAt = sendAt - randInt(5, 120) * 60 * 1000;
    const templateName = idx % 2 === 0 ? randPick(templateNames) : '';
    const smsContent =
      idx % 2 === 0
        ? ''
        : `您的验证码是：${randInt(100000, 999999)}，请在5分钟内使用。`;
    const successRate = `${randInt(92, 100)}.${randInt(0, 9)}%`;
    return {
      id: 1000 + idx + 1,
      status: 2,
      createTime: formatDateTime(createAt),
      sendTime: formatDateTime(sendAt),
      templateName,
      smsContent: buildContent({ templateName, smsContent }),
      successRate,
    };
  });

  const pending = Array.from({ length: 26 }).map((_, idx) => {
    const isSending = idx % 7 === 0;
    const sendAt = isSending
      ? now + randInt(2, 45) * 60 * 1000
      : now + randInt(1, 28) * dayMs + randInt(0, 23) * 60 * 60 * 1000;
    const createAt = now - randInt(1, 72) * 60 * 60 * 1000;
    const templateName = idx % 3 === 0 ? randPick(templateNames) : '';
    const smsContent =
      idx % 3 === 0
        ? ''
        : `【系统通知】您好，您预约的短信将于${formatDateTime(sendAt)}发送。`;
    return {
      id: 2000 + idx + 1,
      status: isSending ? 1 : 0,
      createTime: formatDateTime(createAt),
      sendTime: formatDateTime(sendAt),
      templateName,
      smsContent: buildContent({ templateName, smsContent }),
      successRate: isSending ? '计算中' : '',
    };
  });

  // Sort by sendTime ascending for a stable UX.
  const sortBySendTime = (a, b) => (a.sendTime > b.sendTime ? 1 : a.sendTime < b.sendTime ? -1 : 0);
  return [...pending.sort(sortBySendTime), ...finished.sort(sortBySendTime)];
};

export const getStore = () => {
  const g = getGlobal();
  if (!g[STORE_KEY]) {
    g[STORE_KEY] = { tasks: generateTasks() };
  }
  return g[STORE_KEY];
};

export const listTasks = ({ taskStatus, pageNo, pageSize }) => {
  const store = getStore();
  const status = Number(taskStatus);
  const page = Math.max(1, Number(pageNo) || 1);
  const size = Math.max(1, Number(pageSize) || 10);

  let filtered = store.tasks;
  if (status === 0) {
    filtered = store.tasks.filter((t) => t.status === 0 || t.status === 1);
  } else if (status === 2) {
    filtered = store.tasks.filter((t) => t.status === 2);
  }

  const total = filtered.length;
  const start = (page - 1) * size;
  const list = filtered.slice(start, start + size);

  return { total, list };
};

export const deleteTasks = (ids) => {
  const store = getStore();
  const idSet = new Set((ids || []).map((id) => Number(id)).filter((id) => Number.isFinite(id)));
  if (idSet.size < 1) return 0;

  const before = store.tasks.length;
  store.tasks = store.tasks.filter((t) => !(t.status === 0 && idSet.has(Number(t.id))));
  const after = store.tasks.length;
  return Math.max(0, before - after);
};
